import { toast } from 'react-toastify';

type MyToast = {
    warning(message: string, timeout?: number): void;
    success(message: string, timeout?: number): void;
    error(message: string, timeout?: number): void;
};

const durationDefault = 5000;
const myToast: MyToast = {
    warning: (message: string, timeout: number = durationDefault) => {
        toast.warn(message, { autoClose: timeout });
    },
    error: (message: string, timeout: number = durationDefault) => {
        toast.error(message, { autoClose: timeout });
    },
    success: (message: string, timeout: number = durationDefault) => {
        toast.success(message, { autoClose: timeout });
    }
}
export { myToast };